import React, { useState } from "react";
import { getPrice } from "../Helper";
import { Link } from "react-router-dom";
import CountdownTimer from "./CountdownTimer";

function PriceHtml(props) {
  const [isActive, setIsActive] = useState(false);
  const handleClick = () => {
    setIsActive(!isActive);
  };
  var amount = "";
  if (props.pdata.discount) {
    amount =
      props.pdata.discount_type === "percent"
        ? (props.pdata.price * (100 - props.pdata.discount)) / 100
        : props.pdata.price - props.pdata.discount;

    var discountHtml =
      props.pdata.discount_type === "percent"
        ? "(" + props.pdata.discount + "% OFF)"
        : "(" + props.pdata.symbol + "" + props.pdata.discount + " OFF)";
  } else {
    amount = props.pdata.price;
  }
  var amount = props.pdata.discount
    ? props.pdata.discount_type === "percent"
      ? (props.pdata.price * (100 - props.pdata.discount)) / 100
      : props.pdata.price - props.pdata.discount
    : props.pdata.price;

  return (
    <div className={props.pdata.divclass}>
      {props.pdata.discount ? (
        <>
        <div className="price-box-dis">
          <span className="del">
            {props.pdata.symbol} {getPrice(props?.pdata?.price)}
          </span>
          <span className="price">
            {props.pdata.symbol} {getPrice(amount)}
          </span>
          <span className="off">{discountHtml}</span>
          </div>
          {props.auth?.user?.id &&
            props.welcomeDiscountEnable === 1 &&
            props.auth?.user?.welcome_discount_use !== 1 && (
              <>
                {/* <div className="discount-box">
                <span>Get 5% additional off before the timer runs out</span>
                <span style={{ animation: "blink 1s linear infinite" }}><CountdownTimer
                  initialSeconds={3600}
                  onComplete={() => {}}
                  storageKey="countdown"
                /></span>
                </div> */}
                <span className="product-detail-offers-box">
                  <span className="coupon-code-detail-box last-child"><span className="coupon-code-detail">Get <span>5% additional</span> off before the timer runs out</span><span style={{ animation: "blink 1s linear infinite" }}><CountdownTimer initialSeconds={3600} onComplete={() => {}} storageKey="countdown"/></span></span>
                  {/* <span className="more-offers">More offers</span> */}
                </span>
              </>
            )}
        </>
      ) : (
        <>
          <span className="price">
            {props?.pdata?.symbol} {getPrice(amount)}
          </span>
          {props.pdata.pagefrom === "productDetails" && (
            <>
            {props?.pdata?.is_friday_sale != 1 ? (
            <span className="product-detail-offers-box">
              <span className="coupon-code-detail-box">
              <span className="coupon-code-detail">
                Get{" "}
                <span>{props?.pdata?.coupon_message?.percentage} Discount</span>{" "}
                using Coupon Code{" "}
                <strong>{props?.pdata?.coupon_message?.coupon_name}</strong>
              </span>
              </span>

              {props.auth?.user?.id &&
                props.welcomeDiscountEnable === 1 &&
                props.auth?.user?.welcome_discount_use !== 1 && (
                  <>
                  <span className="coupon-code-detail-box last-child">
                   <span className="coupon-code-detail">
                    Get <span>5% additional</span> off before the timer runs out                    
                    </span>
                    <span style={{ animation: "blink 1s linear infinite" }} className="timer-blinker">
                    <CountdownTimer
                      initialSeconds={3600}
                      onComplete={() => {}}
                      storageKey="countdown"
                    /></span>
                    </span>
                  </>
                )}

              <span onClick={handleClick} className="more-offers">
                More offers
              </span>

              </span>
              ):(
                <>
                
                </>
              )}
            </>
          )}
          {props.pdata.is_details_page === 1 && (
            <div className={`more-offers-wrap ${isActive ? "active" : ""}`}>
              <div className="more-offers-detail">
                <div>
                  Buy 2 or more products to get up to{" "}
                  <strong>30% additional discount</strong>.{" "}
                  <Link
                    to={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NO}?text=Hello%2C+I+have+a+query+regarding+the+offer+${props.pdata.sku}`}
                    target="_blank"
                  >
                    Chat with us
                  </Link>{" "}
                  after making your selection.
                </div>

                <div>
                  Get additional <strong>5% Discount</strong> on partial/full
                  pre-payment (during checkout for orders within India only)
                </div>
              </div>
            </div>
          )}
        </>
      )}
      <div className="delivery_msg" style={{"display":"none"}}>
        <div>{props.pdata.shipping_time}</div>
      </div>
    </div>
  );
}
export default PriceHtml;
